import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "condition-value__inputs" };
import { computed, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { valueType } from '@/utilities/constants';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import CriteriaNumeric from './InputsValue/Numeric.vue';
import CriteriaSelect from './InputsValue/Select.vue';
import CriteriaMultiSelect from './InputsValue/MultiSelect.vue';
import CriteriaAutocomplete from './InputsValue/Autocomplete.vue';
import CriteriaTextInput from './InputsValue/TextInput.vue';
import CriteriaDate from './InputsValue/Date.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConditionValue',
    props: {
        isFilterMode: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { draftCondition, selectedCriteriaDetails, isBetweenOperator } = useAudienceManager(isInclude, groupIndex);
        const hasValidationError = computed(() => {
            return store.getters['audienceManager/conditionHasError'](groupType, groupIndex);
        });
        const criteriaDetails = computed(() => props.isFilterMode && selectedCriteriaDetails.value?.filter
            ? selectedCriteriaDetails.value.filter
            : selectedCriteriaDetails.value);
        const valueKey = computed(() => (props.isFilterMode ? 'f_value' : 'value'));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const computedCurrentValue = computed({
            get: () => (props.isFilterMode ? draftCondition.value?.f_value : draftCondition.value?.value),
            set: newValue => {
                const formattedValue = Array.isArray(newValue) ? [...newValue] : [newValue];
                store.dispatch('audienceManager/updateDraftCondition', {
                    groupType,
                    groupIndex,
                    data: { [valueKey.value]: formattedValue },
                });
            },
        });
        const isOperatorEqual = computed(() => /equal/g.test(draftCondition.value?.operator));
        const isOperatorEqualOrDifferent = computed(() => /equal|different/g.test(draftCondition.value?.operator));
        const errorInputsCount = computed(() => {
            if (!hasValidationError.value)
                return [];
            return isBetweenOperator.value ? [0, 1] : [0];
        });
        const criteriaOptions = computed(() => criteriaDetails?.value?.options || {});
        const hasOptions = computed(() => Object.keys(criteriaOptions.value).length > 0);
        const shouldShowMultiSelect = computed(() => {
            const isMultiSelectEnabled = criteriaDetails?.value?.multiple;
            const isEqualityComparison = isOperatorEqual.value || isOperatorEqualOrDifferent.value;
            return isMultiSelectEnabled && isEqualityComparison;
        });
        const shouldShowAutocomplete = computed(() => criteriaDetails.value?.autocomplete && isOperatorEqualOrDifferent.value);
        const isNumericInput = computed(() => {
            const conditionInputType = criteriaDetails?.value?.type;
            const isIntegerOrDecimal = conditionInputType === valueType.integer || conditionInputType === valueType.decimal;
            return !hasOptions.value && isIntegerOrDecimal;
        });
        const isSimpleTextInput = computed(() => {
            const conditionInputType = criteriaDetails?.value?.type;
            const isStringType = conditionInputType === valueType.string;
            return !hasOptions.value && !isDateInput.value && isStringType;
        });
        const isDateInput = computed(() => {
            const isDateFormat = criteriaDetails?.value?.format === 'date_iso';
            return isDateFormat;
        });
        const getErrorIconClass = (index) => {
            if (isBetweenOperator.value) {
                return index === 0 ? 'left' : 'right';
            }
        };
        watch(() => selectedCriteriaDetails?.value, newCriteria => {
            if (!newCriteria)
                return;
            if (!draftCondition.value?.column || draftCondition.value.column !== newCriteria.key) {
                store.dispatch('audienceManager/updateDraftCondition', {
                    groupType,
                    groupIndex,
                    data: {
                        column: newCriteria.key,
                        operator: newCriteria.operators?.[0] || 'equal',
                        value: [],
                        f_value: [],
                        f_type: '',
                    },
                });
            }
        }, { deep: true, immediate: true });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["condition-value", {
                        'condition-value--error': hasValidationError.value,
                        'condition-value--only-datepicker-error': hasValidationError.value && isDateInput.value,
                        'condition-value--is-between': _unref(isBetweenOperator),
                        multiselectOn: _unref(selectedCriteriaDetails)?.multiple,
                    }])
            }, [
                _createVNode(_component_el_tooltip, {
                    visible: hasValidationError.value,
                    "raw-content": true,
                    content: _ctx.$t('audiences.value-error'),
                    placement: "top",
                    "popper-class": "el--tooltip-error condition-value--tooltip"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            (hasOptions.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(['wrap', { multiselectOn: _unref(selectedCriteriaDetails)?.multiple }])
                                }, [
                                    (shouldShowMultiSelect.value)
                                        ? (_openBlock(), _createBlock(CriteriaMultiSelect, {
                                            key: 0,
                                            modelValue: computedCurrentValue.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedCurrentValue).value = $event))
                                        }, null, 8, ["modelValue"]))
                                        : (_openBlock(), _createBlock(CriteriaSelect, {
                                            key: 1,
                                            modelValue: computedCurrentValue.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((computedCurrentValue).value = $event))
                                        }, null, 8, ["modelValue"]))
                                ], 2))
                                : _createCommentVNode("", true),
                            (isNumericInput.value)
                                ? (_openBlock(), _createBlock(CriteriaNumeric, {
                                    key: 1,
                                    modelValue: computedCurrentValue.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((computedCurrentValue).value = $event))
                                }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                            (isDateInput.value)
                                ? (_openBlock(), _createBlock(CriteriaDate, {
                                    key: 2,
                                    modelValue: computedCurrentValue.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((computedCurrentValue).value = $event))
                                }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                            (isSimpleTextInput.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (shouldShowAutocomplete.value)
                                        ? (_openBlock(), _createBlock(CriteriaAutocomplete, {
                                            key: 0,
                                            modelValue: computedCurrentValue.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((computedCurrentValue).value = $event))
                                        }, null, 8, ["modelValue"]))
                                        : (_openBlock(), _createBlock(CriteriaTextInput, {
                                            key: 1,
                                            modelValue: computedCurrentValue.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((computedCurrentValue).value = $event))
                                        }, null, 8, ["modelValue"]))
                                ], 64))
                                : _createCommentVNode("", true),
                            (hasValidationError.value && !_unref(isBetweenOperator))
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(errorInputsCount.value, (index) => {
                                    return (_openBlock(), _createElementBlock("i", {
                                        key: index,
                                        class: _normalizeClass(["icon icon-attention-14px condition-value__error-icon", getErrorIconClass(index)])
                                    }, null, 2));
                                }), 128))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["visible", "content"])
            ], 2)), [
                [_vShow, _unref(draftCondition)?.column]
            ]);
        };
    }
});
